// extracted by mini-css-extract-plugin
export default {"container":"Toggle_container__As1rf","section":"Toggle_section__nzUcS","selected":"Toggle_selected__4R3h9"};